const setApiBody = (state, action) => action.apiBody || state;

export default setApiBody;
